export const getRestaurantTaxDisplay = ({ chargesContainer, useDmpFields} ) => {
  return (useDmpFields && chargesContainer.merchantTotal) || chargesContainer.restaurantDisplay
}

export const getDinerTax = ({ chargesContainer, useDmpFields }) => {
  return useDmpFields ? chargesContainer.merchantSalesTotal : chargesContainer.salesTotal
}



// WEBPACK FOOTER //
// ./client/app/components/home/taxHelpers.js